import { Box, Skeleton, Typography, Paper } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS = [
  "#8884d8",
  "#82ca9d",
  "#ffc658",
  "#ff7c7c",
  "#8dd1e1",
  "#d084d0",
  "#82d982",
  "#ffb347",
  "#ff85c0",
  "#a4a4a4",
];

const SkuCategoryChart = ({ data, isLoading, error }) => {
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (isLoading || !data) {
    return (
      <Skeleton
        variant="rectangular"
        height={400}
      />
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          height: 400,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography color="textSecondary">No data available</Typography>
      </Box>
    );
  }

  const chartData = {
    labels: data.map((item) => item._id || "Uncategorized"),
    datasets: [
      {
        data: data.map((item) => item.orderCount),
        backgroundColor: COLORS.slice(0, data.length),
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
      title: {
        display: true,
        text: "SKU Category Breakdown",
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.parsed} orders`,
        },
      },
    },
  };

  return (
    <Paper sx={{ p: 2, height: 400 }}>
      <Doughnut
        data={chartData}
        options={options}
      />
    </Paper>
  );
};

export default SkuCategoryChart;
